(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-produkty"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const pad = (n) => String(n).padStart(2, '0');

    function initCountdowns(scope = document) {
      scope.querySelectorAll('[data-bfx-countdown]').forEach((el) => {
        if (el.dataset.ready) return;
        el.dataset.ready = '1';
        const end = new Date(el.dataset.end.trim().replace(' ', 'T'));
        if (isNaN(end.getTime())) return;
        const set = (unit, val) => {
          const node = el.querySelector(`[data-unit="${unit}"]`);
          if (node) node.textContent = pad(val);
        };
        const tick = () => {
          const diff = end.getTime() - Date.now();
          if (diff <= 0) {
            el.hidden = true;
            clearInterval(timer);
            return;
          }
          const s = Math.floor(diff / 1000);
          set('d', Math.floor(s / 86400));
          set('h', Math.floor((s % 86400) / 3600));
          set('m', Math.floor((s % 3600) / 60));
          set('s', s % 60);
          el.hidden = false;
        };
        const timer = setInterval(tick, 1000);
        tick();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCountdowns());
    } else {
      initCountdowns();
    }
    document.addEventListener('shopify:section:load', (e) => initCountdowns(e.target));

    if (window.__bfxCartInit) return;
    window.__bfxCartInit = true;

    function openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function') return drawer.open();
        if (typeof drawer.showDialog === 'function') return drawer.showDialog();
      }
      const trigger = document.querySelector(
        '[data-cart-drawer-trigger], .header-actions__cart-icon, button[aria-controls*="cart"]'
      );
      if (trigger) return trigger.click();
      window.location.href = root + 'cart';
    }

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.bfx-card__form');
      if (!form) return;
      event.preventDefault();

      const btn = form.querySelector('.bfx-btn');
      const text = btn.querySelector('.bfx-btn__text');
      const status = form.querySelector('[data-bfx-status]');
      if (btn.disabled) return;
      const original = btn.dataset.label || text.textContent;

      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      text.textContent = 'Přidávám…';

      const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map((el) => el.dataset.sectionId);

      try {
        const variantId = Number(form.querySelector('[name="id"]').value);
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sectionIds.join(','),
          }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Chyba');

        const cart = await (await fetch(root + 'cart.js')).json();

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'bf-produkty',
              data: {
                source: 'bf-produkty',
                action: 'add',
                itemCount: cart.item_count,
                sections: data.sections || {},
              },
            },
          })
        );

        btn.classList.add('is-added');
        text.textContent = 'Přidáno do košíku';
        if (status) status.textContent = 'Produkt byl přidán do košíku.';
        openCartDrawer();
        setTimeout(() => {
          btn.classList.remove('is-added');
          text.textContent = original;
        }, 2000);
      } catch (err) {
        console.error(err);
        text.textContent = 'Nelze přidat, zkuste znovu';
        if (status) status.textContent = 'Produkt se nepodařilo přidat do košíku.';
        setTimeout(() => (text.textContent = original), 2500);
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-produkt"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const stockText = (n) => {
      if (n === 1) return 'Poslední kus skladem';
      if (n < 5) return `Poslední ${n} kusy skladem`;
      return `Posledních ${n} kusů skladem`;
    };

    function init(sec) {
      if (sec.dataset.pdpReady) return;
      sec.dataset.pdpReady = '1';

      const dataEl = sec.querySelector('[data-pdp-variants]');
      const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      const form = sec.querySelector('.pdp__form');
      const idInput = form && form.querySelector('input[name="id"]');
      if (!idInput) return;

      let current = variants.find((v) => String(v.id) === idInput.value) || variants[0];
      const selected = current ? [...current.options] : [];

      /* Galerie */
      const track = sec.querySelector('[data-track]');
      const thumbs = [...sec.querySelectorAll('[data-thumb]')];
      const slides = track ? [...track.querySelectorAll('[data-media-id]')] : [];

      const goTo = (mediaId) => {
        const slide = slides.find((s) => s.dataset.mediaId === String(mediaId));
        if (!slide || !track) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      };

      if (track) {
        let raf;
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => {
            const i = Math.round(track.scrollLeft / track.clientWidth);
            thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
            const active = thumbs[i];
            if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          });
        }, { passive: true });
        const step = (dir) => track.scrollBy({ left: dir * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        sec.querySelector('[data-prev]')?.addEventListener('click', () => step(-1));
        sec.querySelector('[data-next]')?.addEventListener('click', () => step(1));
      }
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(t.dataset.thumb)));

      /* Varianty */
      const fieldsets = [...sec.querySelectorAll('[data-option-index]')];
      const priceEl = sec.querySelector('[data-price]');
      const compareEl = sec.querySelector('[data-compare]');
      const pctEl = sec.querySelector('[data-pct]');
      const atc = sec.querySelector('.pdp__atc');
      const atcText = atc && atc.querySelector('[data-atc-text]');
      const stockEl = sec.querySelector('[data-stock]');

      function refreshOptions() {
        fieldsets.forEach((fs) => {
          const oi = Number(fs.dataset.optionIndex);
          const label = fs.querySelector('[data-option-value]');
          if (label) label.textContent = selected[oi];
          fs.querySelectorAll('[data-value]').forEach((b) => {
            const val = b.dataset.value;
            b.setAttribute('aria-pressed', String(val === selected[oi]));
            const possible = variants.some(
              (v) => v.available && v.options[oi] === val && v.options.every((o, i) => i === oi || o === selected[i])
            );
            b.classList.toggle('is-unavailable', !possible);
          });
        });
      }

      function updateStock(v) {
        if (!stockEl) return;
        const threshold = Number(stockEl.dataset.threshold) || 0;
        stockEl.classList.remove('is-low', 'is-out');
        if (!v.available) {
          stockEl.classList.add('is-out');
          stockEl.textContent = 'Momentálně vyprodáno';
        } else if (v.qty !== null && v.qty > 0 && v.qty <= threshold) {
          stockEl.classList.add('is-low');
          stockEl.textContent = stockText(v.qty);
        } else {
          stockEl.textContent = stockEl.dataset.in;
        }
      }

      function setVariant(v) {
        current = v;
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) { compareEl.hidden = !v.compare; if (v.compare) compareEl.textContent = v.compare; }
        if (pctEl) { pctEl.hidden = !v.pct; pctEl.textContent = `−${v.pct} %`; }

        if (atc) {
          atc.disabled = !v.available;
          atcText.textContent = v.available ? atc.dataset.label : 'Vyprodáno';
        }
        updateStock(v);
        if (v.media) goTo(v.media);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);

        refreshOptions();
        sec.dispatchEvent(new CustomEvent('pdp:variant-change', { bubbles: true, detail: { variant: v } }));
      }

      fieldsets.forEach((fs) => {
        const oi = Number(fs.dataset.optionIndex);
        fs.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-value]');
          if (!btn) return;
          selected[oi] = btn.dataset.value;
          let match = variants.find((v) => v.options.every((o, i) => o === selected[i]));
          if (!match) {
            match =
              variants.find((v) => v.options[oi] === selected[oi] && v.available) ||
              variants.find((v) => v.options[oi] === selected[oi]);
            if (match) match.options.forEach((o, i) => (selected[i] = o));
          }
          if (match) setVariant(match);
        });
      });
      refreshOptions();

      /* Množství */
      const qtyInput = form.querySelector('[name="quantity"]');
      sec.querySelectorAll('[data-qty]').forEach((b) =>
        b.addEventListener('click', () => {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.qty));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        })
      );
    }

    const initAll = (scope = document) => scope.querySelectorAll('[data-pdp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
    else initAll();
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));

    /* Přidání do košíku + otevření postranního košíku */
    if (window.__pdpCartInit) return;
    window.__pdpCartInit = true;

    function openCartDrawer() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer) {
        if (typeof drawer.open === 'function') return drawer.open();
        if (typeof drawer.showDialog === 'function') return drawer.showDialog();
      }
      const trigger = document.querySelector(
        '[data-cart-drawer-trigger], .header-actions__cart-icon, button[aria-controls*="cart"]'
      );
      if (trigger) return trigger.click();
      window.location.href = root + 'cart';
    }

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest && event.target.closest('.pdp__form');
      if (!form || event.defaultPrevented) return;
      event.preventDefault();

      const btn = form.querySelector('.pdp__atc');
      const text = btn.querySelector('[data-atc-text]');
      const status = form.querySelector('[data-atc-status]');
      const original = btn.dataset.label;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      text.textContent = 'Přidávám…';

      const fd = new FormData(form);
      const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
        .map((el) => el.dataset.sectionId);
      if (sectionIds.length) fd.append('sections', sectionIds.join(','));

      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Chyba');

        const cart = await (await fetch(root + 'cart.js')).json();
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'produkt-hlavni',
              data: {
                source: 'produkt-hlavni',
                action: 'add',
                itemCount: cart.item_count,
                sections: data.sections || {},
              },
            },
          })
        );

        btn.classList.add('is-added');
        text.textContent = 'Přidáno do košíku';
        if (status) status.textContent = 'Produkt byl přidán do košíku.';
        openCartDrawer();
        setTimeout(() => {
          btn.classList.remove('is-added');
          text.textContent = original;
        }, 2000);
      } catch (err) {
        console.error(err);
        text.textContent = 'Nelze přidat, zkuste znovu';
        if (status) status.textContent = 'Produkt se nepodařilo přidat do košíku.';
        setTimeout(() => (text.textContent = original), 2500);
      } finally {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
